// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"y0-z","inlineTitle":"z0-z","sponsoredAdsWrapper":"A0-z","marketplaceRecosWrapper":"B0-z","brandShopTheLookWrapper":"C0-z"};